import * as React from "react";
import { StreamingOpenTrades } from "./StreamingOpenTrades";
import { AppState } from "../Store/RootReducer";
import { connect } from "react-redux";
import { WrappedComponentProps, injectIntl } from "react-intl";
import { TradesByMarketAndValueDateGrid, TradesByMarketAndValueDateGridProps } from "./TradesByMarketAndValueDateGrid";
import { FxRatesConsumer } from "../Api/FxRates";

interface PropsFromState {
  activeTradingAccountKey: string;
}

interface Props extends PropsFromState, WrappedComponentProps, TradesByMarketAndValueDateGridProps { }

class ActiveTradingAccountStreamingOpenTradesByMarketAndValueDateGridCmp extends React.PureComponent<Props> {
  public render() {
    return (
      <FxRatesConsumer>
        {fxRates => (
          <StreamingOpenTrades groupKey={this.props.activeTradingAccountKey} fxRates={fxRates} >
            {trades =>
              <TradesByMarketAndValueDateGrid
                trades={trades}
                marketKey={this.props.marketKey}
                pagination={this.props.pagination}
                bordered={this.props.bordered}
                title={this.props.title}
              />
            }
          </StreamingOpenTrades>
        )}
      </FxRatesConsumer>
    );
  }
}

const ActiveTradingAccountStreamingOpenTradesByMarketAndValueDateGridWithIntl = injectIntl(ActiveTradingAccountStreamingOpenTradesByMarketAndValueDateGridCmp);

const mapStateToProps = (state: AppState, ownProps: TradesByMarketAndValueDateGridProps): PropsFromState => {
  return {
    activeTradingAccountKey: state.activeTradingAccount.account!.Key,
    ...ownProps
  };
};

export const ActiveTradingAccountStreamingOpenTradesByMarketAndValueDateGrid = connect(mapStateToProps)(ActiveTradingAccountStreamingOpenTradesByMarketAndValueDateGridWithIntl);
